module.exports = __webpack_public_path__ + "static/media/arrow-right-pink.889506fb.svg";